module.exports = "/_next/static/images/profile-ant-eb9c9e15527771a54d4acba699c83196.png";